import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import styled from "styled-components";
import x from "../assets/x.svg";
import { translate, Translate } from "../components/translate";
import { useLanguage } from "../stores/language_store";
import { TaskModel } from "../models/task";

export function ToDoList() {
  const [taskName, setTaskName] = useState<string>("");
  const [taskToDo, setTaskToDo] = useState<TaskModel[]>([]);
  const [taskDone, setTaskDone] = useState<TaskModel[]>([]);
  const language = useLanguage();

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setTaskName(e.target.value);
  }, []);

  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (taskName !== undefined && e.key === "Enter") {
        setTaskToDo((prev) => [
          ...prev,
          {
            id: Math.random(),
            name: taskName,
          },
        ]);
        setTaskName("");
      }
    },
    [taskName]
  );

  const removeTask = useCallback((taskToRemove: TaskModel) => {
    setTaskToDo((prev) => prev.filter((task) => task.id !== taskToRemove.id));
    setTaskDone((prev) => prev.filter((task) => task.id !== taskToRemove.id));
  }, []);

  const addTaskDone = useCallback((taskToRemove: TaskModel) => {
    setTaskToDo((prev) => prev.filter((task) => task.id !== taskToRemove.id));
    setTaskDone((prev) => [...prev, taskToRemove]);
  }, []);

  const removeTaskDone = useCallback((taskToRemove: TaskModel) => {
    setTaskDone((prev) => prev.filter((task) => task.id !== taskToRemove.id));
    setTaskToDo((prev) => [...prev, taskToRemove]);
  }, []);

  return (
    <ContainerList>
      <Title>
        <Translate value="to_do_list" />
      </Title>
      <Input
        type="text"
        placeholder={translate("add_task", language)}
        value={taskName}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />

      {taskToDo.length > 0 ? (
        <>
          <Translate value="to_do" />
          {taskToDo.map((task) => (
            <ContainerTask
              key={task.id}
              onClick={() => {
                addTaskDone(task);
              }}
              $isSelected={false}
            >
              <Task>{task.name}</Task>
              <ImageX
                src={x}
                alt="x"
                onClick={(e) => {
                  e.stopPropagation();
                  removeTask(task);
                }}
              />
            </ContainerTask>
          ))}
        </>
      ) : (
        <></>
      )}
      {taskDone.length > 0 ? (
        <>
          <Translate value="done" />
          {taskDone.map((task) => (
            <ContainerTask
              key={task.id}
              onClick={() => {
                removeTaskDone(task);
              }}
              $isSelected={true}
            >
              <Task>{task.name}</Task>
              <ImageX
                src={x}
                alt="x"
                onClick={(e) => {
                  e.stopPropagation();
                  removeTask(task);
                }}
              />
            </ContainerTask>
          ))}
        </>
      ) : (
        <></>
      )}
      {taskToDo.length === 0 && taskDone.length === 0 ? (
        <Translate value="no_task" />
      ) : (
        <></>
      )}
    </ContainerList>
  );
}

const ContainerList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

const Title = styled.h1``;

const Input = styled.input`
  width: 80%;
  padding: 10px;
  &:hover {
    border: 2px solid #717070;
  }
`;

const Task = styled.div``;

const ContainerTask = styled.div<{ $isSelected: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 80%;
  padding: 10px;
  border: 2px solid #717070;
  border-radius: 5px;
  &:hover {
    background-color: #717070;
  }
  text-decoration: ${({ $isSelected }) =>
    $isSelected ? "line-through" : "none"};
`;

const ImageX = styled.img`
  cursor: pointer;
`;
